import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { EmojiPickerService } from '@recruitee/emoji';
import { htmlToJson, MentionType, RtSchema } from '@recruitee/prosemirror';
import { MentionsStream$ } from '@recruitee/prosemirror/angular';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ProsemirrorConfig } from '../../../../libs/prosemirror/angular/src/components/wysiwg/prosemirror.service';

const exampleInitial = {
  doc: {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            type: 'mention',
            attrs: { 'data-id': 3, 'data-type': 'user' },
            content: [{ type: 'text', text: 'Holly Stevenson' }],
          },
          { type: 'text', text: ' Hello ' },
          { type: 'text', text: '🧑‍🚀 ' },
        ],
      },
      {
        type: 'paragraph',
        content: [
          { type: 'text', text: 'some text ' },
          {
            type: 'text',
            marks: [{ type: 'strong' }],
            text: 'STRONG',
          },
        ],
      },
      {
        type: 'paragraph',
        content: [
          {
            type: 'legacy_mention',
            content: [
              {
                type: 'text',
                text: 'Adam Skołuda 3',
              },
            ],
          },
          {
            type: 'text',
            text: ' test',
          },
        ],
      },
    ],
  },
};
const initialHTML = `<p><span class="mention">Adam Skołuda 3</span> asd</p>`;

@Component({
  selector: 'recruitee-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  providers: [
    EmojiPickerService,
    {
      provide: MentionsStream$,
      useValue: new BehaviorSubject([
        { id: 1, type: MentionType.User, name: 'Asad Hurley', avatar: 'https://picsum.photos/200' },
        { id: 2, type: MentionType.User, name: 'Ajwa Lees', avatar: 'https://picsum.photos/200' },
        {
          id: 3,
          type: MentionType.User,
          name: 'Fathima Lopez',
          avatar: 'https://picsum.photos/200',
        },
        { id: 4, type: MentionType.User, name: 'Ammara Cano', avatar: 'https://picsum.photos/200' },
        {
          id: 5,
          type: MentionType.User,
          name: 'Mathilde Ingram',
          avatar: 'https://picsum.photos/200',
        },
        {
          id: 1,
          type: MentionType.Role,
          name: 'Bathtub Flying',
          avatar: 'https://picsum.photos/200',
        },
        { id: 2, type: MentionType.Role, name: 'Sausageback', avatar: 'https://picsum.photos/200' },
        {
          id: 3,
          type: MentionType.Role,
          name: 'One Zillion Flying Iced Tigers',
          avatar: 'https://picsum.photos/200',
        },
        { id: 4, type: MentionType.Role, name: 'Deaf Tigers', avatar: 'https://picsum.photos/200' },
        {
          id: 5,
          type: MentionType.Role,
          name: 'The Love of Hands',
          avatar: 'https://picsum.photos/200',
        },
      ]),
    },
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  public ProsemirrorConfig = ProsemirrorConfig;
  public exampleInitial = exampleInitial;
  public formControl = new FormControl(exampleInitial);
  public htmlInput = new FormControl();
  public selectedEmoji: any;

  private ngOnDestroy$ = new Subject();

  constructor(private cdRef: ChangeDetectorRef, private emojiPickerService: EmojiPickerService) {}

  public ngOnInit() {
    this.formControl.valueChanges.subscribe(value => {
      this.exampleInitial = value;
      this.cdRef.detectChanges();
      console.log(value);
    });

    this.htmlInput.valueChanges
      .pipe(map(html => htmlToJson(html, RtSchema.Default)))
      .subscribe(json => {
        this.formControl.setValue(json);
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public openEmojiPicker(elRef: ElementRef<HTMLElement>) {
    const rect = elRef.nativeElement.getBoundingClientRect();
    this.emojiPickerService.open(rect, { withSearch: true }).select$.subscribe(value => {
      this.selectedEmoji = String.fromCodePoint(<any>`0x${value.unified}`);
      this.emojiPickerService.close();
      this.cdRef.detectChanges();
    });
  }
}
